module.exports = __webpack_public_path__ + "img/45000.dc9722e7.jpg";